import { gql } from "config/graphql";
import { IUser } from "config/types";
import { gqlQuery } from "store/apollo";

interface IFetchLatestInsuranceApplicationResponse {
  data: {
    me: Pick<IUser, "activeConstellations">;
  };
}

interface IFetchLatestInsuranceApplicationDocumentsResponse {
  data: {
    me: Pick<IUser, "activeConstellations">;
  };
}

export const fetchLatestInsuranceApplication =
  async (): Promise<IFetchLatestInsuranceApplicationResponse> => {
    const query = gql`
      query LatestInsuranceApplication {
        me {
          activeConstellations {
            activeInsuranceMembership {
              latestInsuranceApplication {
                id
                result
                version
              }
            }
          }
        }
      }
    `;

    return gqlQuery<IFetchLatestInsuranceApplicationResponse["data"]>({ query });
  };

export const fetchLatestInsuranceApplicationDocuments =
  (): Promise<IFetchLatestInsuranceApplicationDocumentsResponse> => {
    const query = gql`
      query LatestInsuranceApplicationDocument {
        me {
          activeConstellations {
            activeInsuranceMembership {
              latestInsuranceApplication {
                documents {
                  html {
                    url
                  }
                  pdf {
                    url
                  }
                  slug
                }
              }
            }
          }
        }
      }
    `;

    return gqlQuery<IFetchLatestInsuranceApplicationDocumentsResponse["data"]>({ query });
  };
